module.exports = __webpack_public_path__ + "static/media/slide-image-3-small-min-2.24aed660.jpeg";